//import BaseUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelInformationTracking from "@/models/BaseModelInformationTracking.js";
import BaseModelIssuance from "@/models/BaseModelIssuance.js";
import BaseModelTransfer from "@/models/BaseModelTransfer.js";
import VestingMixin from "@/mixins/VestingMixin.js";
import moment from "moment";
import BaseModelVesting from "@/models/BaseModelVesting.js";
import deepGroupBy from "@/services/groupByUtil.js";
import { isNullOrUndefined } from "util";

export default {
    name: "BuyoutMixin",
    mixins: [VestingMixin],
    methods: {
        startBuyoutProcess: function (partnerID,LeaveDate) {
            const self = this;
            let unitRunningTotalAPIData = [];
            let buyoutRecord=[];

            let VestingAPIfetchdata=self.getVestingData(new Date(LeaveDate));
            console.log("Vesting API Fetch Data",VestingAPIfetchdata)
            
            //Fetch Unit Running total
            partnerID.forEach(partner => {
                let filterQuery = {
                    filter: "PartnerId eq " + partner.PartnerId
                };
                let runningTotalOutput = self.withFilter(
                    // BaseUnitRunningTotal.list,
                    BaseModelTransactionLog.list,
                    filterQuery
                );
                console.log("Unit Running Total API Data Before Concat: ", runningTotalOutput);
                unitRunningTotalAPIData=unitRunningTotalAPIData.concat(runningTotalOutput);
            })
            console.log("Unit Running Total API Data: ", unitRunningTotalAPIData);
            console.log("Unit Running Total API Data Length: ", unitRunningTotalAPIData.length);

            let helper = {};
              let result = unitRunningTotalAPIData.reduce(function(r, o) {
                let key = o.ProgramId+ '-' + o.UnitClass;
                
                if(!helper[key]) {
                  helper[key] = Object.assign({}, o); // create a copy of o
                  r.push(helper[key]);
                } else {
                  helper[key].Unit += o.Unit;
                }
              
                return r;
            }, []);

            //unitRunningTotalAPIData = []
            //unitRunningTotalAPIData = result;

            console.log('Unit Running Total API Data After Filter: ', unitRunningTotalAPIData);

            unitRunningTotalAPIData.forEach(unitRunningTotal => {
                
                let buyoutSaveData={};

                //Fetch price from unit class
                let unitClassQuery = {
                    batchQuery: true,
                    filter: function (o) {
                        return o.ProgramId == unitRunningTotal.ProgramId && o.UnitClass == unitRunningTotal.UnitClass
                    }
                }
                let unitclassresult = self.withFilter(
                    BaseModelUnitClass.list,
                    unitClassQuery
                )[0];
                if(unitclassresult && unitclassresult.UnitPrice)
                {
                    buyoutSaveData.UnitPrice=unitclassresult.UnitPrice;
                    //console.log("Unit Price", unitclassresult.UnitPrice);
                }
               
                //Fetch Payment from information Tracker
                let informationTrackingQuery = {
                    batchQuery: true,
                    filter: function (o) {
                        return o.ProgramId == unitRunningTotal.ProgramId 
                        && o.PartnerId == unitRunningTotal.PartnerId
                    }
                }
                let infoTrackresult = self.withFilter(
                    BaseModelInformationTracking.list,
                    informationTrackingQuery
                )[0];
                if(infoTrackresult && infoTrackresult.Payment)
                {
                    buyoutSaveData.AmountPaidForProgram=infoTrackresult.Payment;
                    //console.log("payment", infoTrackresult.Payment);
                }

                //Fetch vested unit 
                var vestingData =_.filter(VestingAPIfetchdata, function(VestingData) {
                    return VestingData.ProgramId == unitRunningTotal.ProgramId
                    && VestingData.ReceiverId == unitRunningTotal.PartnerId
                    && VestingData.UnitClass == unitRunningTotal.UnitClass
                    && VestingData.UnitPool == unitRunningTotal.UnitPool
                    && VestingData.UnitType == unitRunningTotal.UnitType
                    && VestingData.VestingType ==unitRunningTotal.VestingType
                    })[0];
                if(vestingData && vestingData.VestedUnit)
                {
                  /*
                  if (vestingData.ProgramId == 120 && vestingData.ReceiverId == 2097)
                  {
                          buyoutSaveData.VestedUnit=vestingData.VestedUnit;
                  }
                  */
                         buyoutSaveData.VestedUnit=vestingData.VestedUnit;
                        //console.log("payment", infoTrackresult.Payment);
                }

                
                
                
                // set values for buyout record
                buyoutSaveData.ProgramId=unitRunningTotal.ProgramId;
                buyoutSaveData.PartnerId=unitRunningTotal.PartnerId;
                buyoutSaveData.UnitClass=unitRunningTotal.UnitClass;
                buyoutSaveData.UnitType=unitRunningTotal.UnitType;
                buyoutSaveData.UnitPool=unitRunningTotal.UnitPool;
                buyoutSaveData.Unit=unitRunningTotal.Unit;
                buyoutSaveData.ConvertToTreasury="Yes";
                buyoutSaveData.Status="Pending";
                buyoutSaveData.VestingType=unitRunningTotal.VestingType;

                buyoutRecord.push(buyoutSaveData);

            })
            console.log("Buyout data",buyoutRecord);
            return buyoutRecord;
           
        },
        getVestingData(inputDate) {
            const self = this;
            this.VestingReportData = [];
            let VestingQuery = {
              batchQuery: true,
              filter: function(o) {
                return (
                  o.BusinessEvent == "Vesting" &&
                  (o.WorkflowStatus == "Approved" ||
                    o.WorkflowStatus == "Correction Pending" ||
                    o.WorkflowStatus == "Correction Approved") &&
                    moment(o.VestedDate) < moment(inputDate)
                  //o.SpecialArrangement != "Overridden" &&
                  
                );
              }
            };
            let VestingReportDataTemp = this.withFilter(
              BaseModelVesting.list,
              VestingQuery
            );
            //Issunace Data
            let IssuanceQuery = {
              batchQuery: true,
              filter: function(o) {
                return (
                  (o.WorkflowStatus == "Approved" && o.ReceiverId!=1)
                  && (o.VestingType == "Standard"
                  || (o.VestingType=='Cliff' && !isNullOrUndefined(o.VestCliffDate)))
                );
              }
            };
            self._getVestingFromTransactions(
              BaseModelIssuance,
              IssuanceQuery,
              VestingReportDataTemp,
              inputDate
            );
            //Transfer datal
            let TransferQuery = {
              batchQuery: true,
              filter: function(o) {
                return (
                  o.WorkflowStatus == "Approved" &&
                  o.VestingType != "Custom"
                );
              }
            };
            self._getVestingFromTransactions(
              BaseModelTransfer,
              TransferQuery,
              VestingReportDataTemp,
              inputDate
            );
      

            let aggregatedResult = []
            //Aggregate By Program and UnitType
            const getConfig10 = item => item.BusinessEvent;

            const getConfig1 = item => item.ProgramId;
            const getConfig2 = item => item.ReceiverId;
            const getConfig3 = item => item.UnitClass;
            const getConfig4 = item => item.UnitType;
            const getConfig5 = item => item.VestingType;
            const getConfig6 = item => item.UnitPool;

            const getConfig7 = item => item.VestStartDate;
            const getConfig8 = item => item.Year;
            const getConfig9 = item => item.VestedDate;


            let groupByResult = deepGroupBy(
              VestingReportDataTemp,
                getConfig1,
                getConfig2,
                getConfig3,
                getConfig4,
                getConfig5,
                getConfig6,
                getConfig7,
                getConfig8,
                getConfig9,
                getConfig10
            );
            Object.keys(groupByResult).forEach(function (programKey, programIndex) {
                let programResult = groupByResult[programKey];
                Object.keys(programResult).forEach(function(partnerKey, partnerIndex) {
                  let partnerResult = programResult[partnerKey];
                    Object.keys(partnerResult).forEach(function(unitClassKey,unitClassIndex) {
                      let unitClassResult = partnerResult[unitClassKey];
                      Object.keys(unitClassResult).forEach(function(unitTypeKey,unitTypeIndex) {
                        let unitTypeResult = unitClassResult[unitTypeKey];
                        Object.keys(unitTypeResult).forEach(function(vestTypeKey,vestTypeIndex) {
                          let vestTypeResult = unitTypeResult[vestTypeKey];
                          Object.keys(vestTypeResult).forEach(function(unitPoolKey,unitPoolIndex) {
                          let unitPoolResult = vestTypeResult[unitPoolKey];

                          Object.keys(unitPoolResult).forEach(function(businesseventTypeKey,businesseventTypeIndex) {
                            let businesseventTypeResult = unitPoolResult[businesseventTypeKey];
                            Object.keys(businesseventTypeResult).forEach(function(vestStartDateKey,vestStartDateIndex) {
                              let vestStartDateResult = businesseventTypeResult[vestStartDateKey];
                              Object.keys(vestStartDateResult).forEach(function(yearKey,yearIndex) {
                                let yearResult = vestStartDateResult[yearKey];
                                Object.keys(yearResult).forEach(function(vestedDateKey,vestedDateIndex) {
                                  let vestedDateResult = yearResult[vestedDateKey];

                                  let row = _.clone(vestedDateResult[0]);

                    //let row = vestedDateResult;
                    
                    /*
                    let row = {};
                    row.BusinessEvent = unitTypeResult[0].BusinessEvent;

                    //row.PartnerId = unitTypeResult[0].ReceiverId;
                    row.ReceiverId = unitTypeResult[0].ReceiverId;
                    row.ProgramId = unitTypeResult[0].ProgramId;
                    row.Unit = unitTypeResult[0].Unit;
                    row.UnitType =  unitTypeResult[0].UnitType;
                    row.VestedUnit = unitTypeResult[0].VestedUnit;
                    //row.Percentage = unitTypeResult[0].Percentage;
                    row.Percentage = unitTypeResult[0].Percentage;
                    */


                    aggregatedResult.push(row)
                            });
                          });
                        });
                      });
                    });
                  });
                });
              });
                })

            });

            VestingReportDataTemp = aggregatedResult;

            //Aggregate VestingReportData-- Taking in Account Transfers
            return self.AggregateVestingData(VestingReportDataTemp,inputDate);
          },
          AggregateVestingData(VestingData,inputDate) {
            const self=this;
            let TempVesting = [];
            const getConfig1 = item => item.ProgramId;
            const getConfig2 = item => item.ReceiverId;
            const getConfig3 = item => item.UnitClass;
            const getConfig4 = item => item.UnitType;
            const getConfig5 = item => item.VestingType;
            const getConfig6 = item => item.UnitPool;
      
            var groupByResult = deepGroupBy(
              VestingData,
              getConfig1,
              getConfig2,
              getConfig3,
              getConfig4,
              getConfig5,
              getConfig6
            );
            //console.log("grouped data");
            //console.log(groupByResult)
      
            Object.keys(groupByResult).forEach(function(programKey, programIndex) {
              let programResult = groupByResult[programKey];
              Object.keys(programResult).forEach(function(partnerKey, partnerIndex) {
                let partnerResult = programResult[partnerKey];
                Object.keys(partnerResult).forEach(function(unitClassKey,unitClassIndex) {
                  let unitClassResult = partnerResult[unitClassKey];
                  Object.keys(unitClassResult).forEach(function(unitTypeKey,unitTypeIndex) {
                    let unitTypeResult = unitClassResult[unitTypeKey];
                    Object.keys(unitTypeResult).forEach(function(vestTypeKey,vestTypeIndex) {
                      let vestTypeResult = unitTypeResult[vestTypeKey];
                      Object.keys(vestTypeResult).forEach(function(unitPoolKey,unitPoolIndex) {
                      let unitPoolResult = vestTypeResult[unitPoolKey];
                        let row = _.clone(unitPoolResult[0]);
                        row.Unit=_.sumBy(unitPoolResult, 'Unit');
                        /*
                        if (unitPoolResult[0].ProgramId == 120 && unitPoolResult[0].ReceiverId == 2097)
                          {
                            row.VestedUnit=_.sumBy(unitPoolResult,"VestedUnit");
                          }
                        */
                        row.VestedUnit=_.sumBy(unitPoolResult,"VestedUnit");
                        row.Percentage=row.VestedUnit/row.Unit;
                        TempVesting.push(row)
                    })
                      
                    });
                  });
                });
              });
            });
      
            VestingData.forEach(transaction => {
              if (transaction.SenderId) {
                let index=TempVesting.findIndex(function(ele) {
                  return ele.ProgramId==transaction.ProgramId && ele.ReceiverId==transaction.SenderId
                  && ele.UnitClass==transaction.UnitClass && ele.UnitType==transaction.UnitType
                  && ele.VestingType==transaction.VestingType && ele.UnitPool==transaction.UnitPool
                })
                if (index>=0) {
                  TempVesting[index].Unit=TempVesting[index].Unit-transaction.Unit;
                  /*
                  if (TempVesting[index].ProgramId == 120 && TempVesting[index].ReceiverId == 2097)
                  {
                    TempVesting[index].VestedUnit=TempVesting[index].VestedUnit-transaction.VestedUnit
                  }
                  */
                  TempVesting[index].VestedUnit=TempVesting[index].VestedUnit-transaction.VestedUnit
                  TempVesting[index].Percentage=TempVesting[index].VestedUnit/TempVesting[index].Unit
                }
              }
            });
            //self.VestingReportData = TempVesting;
            //Fetch records from only Vesting Table with Override
            let overrideVestQuery = {
              batchQuery: true,
              filter: function(o) {
                return (
                  o.BusinessEvent == "Vesting" &&
                  (o.WorkflowStatus == "Approved" ||
                    o.WorkflowStatus == "Correction Pending" ||
                    o.WorkflowStatus == "Correction Approved") &&
                  o.SpecialArrangement == "Override" &&
                  moment(o.VestedDate) < moment(inputDate)
                );
              }
            };
            let VestingOverrideResult = this.withFilter(
              BaseModelVesting.list,
              overrideVestQuery
            );
            let orderedResult=_.reverse(_.sortBy(VestingOverrideResult, [function(o) { return o.Modified; }]))
            //Replcae Temp Vesting Array with Override Data.
            TempVesting.forEach(vestingRow => {
              let index=orderedResult.findIndex(function(ele) {
                  return ele.ProgramId==vestingRow.ProgramId && ele.ReceiverId==vestingRow.ReceiverId
                  && ele.UnitClass==vestingRow.UnitClass && ele.UnitType==vestingRow.UnitType
                  && ele.VestingType==vestingRow.VestingType && ele.UnitPool==vestingRow.UnitPool
                })
                if (index>=0) {
                  /*
                  if (vestingRow.ProgramId == 120 && vestingRow.ReceiverId == 2097)
                  {
                    vestingRow.VestedUnit=orderedResult[index].VestedUnit
                  }
                  */
                  vestingRow.VestedUnit=orderedResult[index].VestedUnit
                  vestingRow.VestedDate=orderedResult[index].VestedDate
                  vestingRow.Percentage=orderedResult[index].Percentage
                  vestingRow.SpecialArrangement=orderedResult[index].SpecialArrangement
                  vestingRow.Unit=vestingRow.VestedUnit/vestingRow.Percentage
                }
            });
            //Assign to Kendo Grid
            return TempVesting;
          },
        uniqueTransValueWithSum(unitRunningTotal) {
          var transArray = [];
          

        }
    }
}